// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"f57b7e89","359":"636260f3","361":"64e9e206","511":"3c1b9aa1"}[chunkId] + ".chunk.js";
};